import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import { Layout } from "./components/Layout";
import { htmlRedirects } from "./config/routes";
import { HomePage } from "./pages/HomePage";
import {
  AboutPage,
  ContactPage,
  DeliveryReturnsPage,
  FaqPage,
  NotFoundPage,
  TermsPage
} from "./pages/InformationPages";
import { CartPage } from "./pages/CartPage";
import { ProductPage } from "./pages/ProductPage";
import { SearchPage } from "./pages/SearchPage";
import { ShopPage } from "./pages/ShopPage";

function RedirectWithSearch({ to }: { to: string }) {
  const [params] = useSearchParams();
  const search = params.toString();
  return <Navigate to={search ? `${to}?${search}` : to} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="index.html" element={<HomePage />} />
        <Route path="shop" element={<ShopPage />} />
        <Route path="shop/:categorySlug" element={<ShopPage />} />
        <Route path="search" element={<SearchPage />} />
        <Route path="bag" element={<CartPage />} />
        <Route path="bundles/:slug" element={<ProductPage bundleOnly />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="delivery-returns" element={<DeliveryReturnsPage />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="product.html" element={<ProductPage />} />
        <Route path="products/:slug" element={<ProductPage />} />
        <Route path="pages/contact.html" element={<ContactPage />} />
        <Route path="404.html" element={<NotFoundPage />} />
        {htmlRedirects.map((redirect) => (
          <Route
            key={redirect.from}
            path={redirect.from}
            element={<RedirectWithSearch to={redirect.to} />}
          />
        ))}
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
